import AnimatedBanner from "@src/lib/ui/AnimatedBanner";
import useVersionQueryParams from "@src/features/libraryItem/hooks/useVersionQueryParams";
import { cn } from "@src/lib/utils/cn";

const LockedTrainingResourceVersionBanner: React.FC = () => {
  const { version } = useVersionQueryParams();

  return (
    <div
      className={cn(
        "flex flex-col self-stretch px-3",
        version === "published" && "mb-3",
      )}
    >
      <AnimatedBanner
        showBanner={version === "published"}
        text="You're viewing the Published version. Select the Draft version to make changes."
      />
    </div>
  );
};

export default LockedTrainingResourceVersionBanner;
